export const convertFileToBase64 = file => {
  const reader = new FileReader();

  return new Promise(resolve => {
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
};
